var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPlusGray(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14.0 14.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.00779125,0.172925734 L4.74998137,3.91516953 L8.49217383,0.172972686 C8.72273909,-0.0575928513 9.09651081,-0.0575928513 9.32707607,0.172972686 C9.5576394,0.403503295 9.5576394,0.777313152 9.32707607,1.00787674 L5.58493215,4.75002506 L9.32707607,8.49217337 C9.5576415,8.72273907 9.5576415,9.09651173 9.32707607,9.32707743 C9.09651291,9.55764086 8.722704,9.55764086 8.49218647,9.32709007 L4.74998254,5.58488175 L1.00779125,9.32707743 C0.777225984,9.55764297 0.40345427,9.55764297 0.172889003,9.32707743 C-0.0576315813,9.09655657 -0.0576315813,8.72272721 0.172901649,8.49216072 L3.91508104,4.74997694 L0.172887839,1.00782863 C-0.0576315813,0.777308936 -0.0576315813,0.403479573 0.172901649,0.172913088 C0.40345427,-0.0576398036 0.777225984,-0.0576398036 1.00779125,0.172925734 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-314.0 -489.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(321.0000018567215 489.28248405195535) rotate(44.99999999999999)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i1)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0,4.54747351e-13 9.50000015,4.54747351e-13 9.50000015,9.50000158 0,9.50000158 0,4.54747351e-13",
    stroke: "none",
    fill: "#333333"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPlusGray);
export default __webpack_public_path__ + "static/media/icPlusGray.2676a09858c7efb0dcca7457b2ad0948.svg";
export { ForwardRef as ReactComponent };